import { FaGlobe } from 'react-icons/fa6'
import AnimatedSection from '../common/AnimatedSection'
import { servicesGlobalTrading } from '../../data/servicesPageData'

const servicesGlobalCollage = '/assets/services-global-collage.png'

function ServicesGlobalTrading() {
  const { eyebrow, titleLine1, titleAccent, titleLine2, description, highlights } =
    servicesGlobalTrading

  return (
    <AnimatedSection className="services-global-section">
      <div className="container corp-container">
        <div className="row g-4 g-lg-5 align-items-center">
          <div className="col-lg-6">
            <div className="services-global__visual">
              <span className="services-global__dots" aria-hidden="true" />
              <img
                src={servicesGlobalCollage}
                alt="Global trade routes, international shipping and industrial metal warehousing"
                loading="lazy"
              />
            </div>
          </div>
          <div className="col-lg-6">
            <div className="services-global__copy">
              <span className="section-label section-label--gold">{eyebrow}</span>
              <h2 className="services-global__title">
                {titleLine1}{' '}
                <span className="services-global__title-accent">{titleAccent}</span>
                <br />
                {titleLine2}
              </h2>
              <p>{description}</p>
              <div className="services-global__highlights" role="list">
                {highlights.map((item) => (
                  <span className="services-global__pill" key={item} role="listitem">
                    <FaGlobe aria-hidden="true" />
                    {item}
                  </span>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </AnimatedSection>
  )
}

export default ServicesGlobalTrading
